<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.beginning_balance_feature.beginning_balance') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="
                    $t('addministration.beginning_balance_feature.search')
                  "
                  style="width: 300px;"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td>{{ record.balance_date }}</td>
              <td>
                {{
                  record.delivered !== null ? record.delivered.full_name : ''
                }}
              </td>
              <td class="text-center">
                {{
                  record.delivered_amount + ' ' + record.currency.currency_code
                }}
              </td>
              <td>
                {{ record.received !== null ? record.received.full_name : '' }}
              </td>
              <td>
                {{ $store.getters.limitStringShow(record.description, 30) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  v-tooltip="
                    $t('addministration.beginning_balance_feature.edit')
                  "
                  class="text-primary mr-3"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="
                    $t('addministration.beginning_balance_feature.delete')
                  "
                  class="text-danger"
                  @click.prevent="destroy(record.balance_id)"
                >
                  <i class="fas fa-trash"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'

export default {
  components: {
    FormCreate
  },
  name: 'beginning-balance',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false
    }
  },
  computed: {
    ...mapState('beginningBalance', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.beginningBalance.search
      },
      set(newVal) {
        this.$store.commit('beginningBalance/SET_SEARCH', newVal)
        this.$store.commit('beginningBalance/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('addministration.beginning_balance_feature.date'),
          style: 'width: 12%;'
        },
        {
          name: this.$t(
            'addministration.beginning_balance_feature.delivered_by'
          ),
          style: 'width: 18%;'
        },
        {
          name: this.$t('addministration.beginning_balance_feature.amount'),
          style: 'width: 15%;text-align:center'
        },
        {
          name: this.$t(
            'addministration.beginning_balance_feature.received_by'
          ),
          style: 'width: 18%;'
        },
        {
          name: this.$t('addministration.beginning_balance_feature.description')
        },
        {
          name: this.$t('addministration.beginning_balance_feature.action'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('beginningBalance/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    edit(data) {
      this.route_leave = false
      this.edit_data = data
      this.$router.push(`/beginning-balances/${data.balance_id}`)
    },

    async destroy(id) {
      if (
        await this.$confirmModal.danger(
          this.$t(
            'addministration.beginning_balance_feature.are_you_sure_to_delete'
          )
        )
      ) {
        this.$store
          .dispatch('beginningBalance/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'beginning-balance-create') {
      this.$store.commit('beginningBalance/RESET_STATE')
      this.$store.commit('beginningBalance/SET_CURRENCIES', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
